export default "__VITE_ASSET__6e6783b0__"